import { getLocaleFromLanguageCode } from './locale';
import Logger from './Logger';

var getCurrencySymbol = function getCurrencySymbol(currency) {
  switch (currency) {
    case 'SEK':
      return 'kr';

    case 'NOK':
      return 'kr';

    case 'EUR':
      return '€';

    default:
      {
        Logger.warn("Currency symbol for '".concat(currency, "' not configured, fallback to ").concat(currency));
        return currency;
      }
  }
};

var getCurrencyFormat = function getCurrencyFormat(amount, currency, locale) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    decimals: 2
  };

  if (locale) {
    return new Intl.NumberFormat(getLocaleFromLanguageCode(locale), {
      style: 'currency',
      currency: currency
    }).format(amount);
  } else {
    Logger.warn('Locale not sent to getCurrencyFormat, formatting it manually.');
    var symbol = getCurrencySymbol(currency);
    var number = Number(amount).toFixed(options.decimals);
    var symbolFirst = "".concat(symbol).concat(number);
    var amountFirst = "".concat(number, " ").concat(symbol);

    switch (currency) {
      case 'NOK':
      case 'SEK':
        return amountFirst;

      case 'EUR':
        return symbolFirst;

      default:
        {
          Logger.warn("Currency '".concat(currency, "' not configured, fallback to ").concat(amountFirst));
          return amountFirst;
        }
    }
  }
};

export { getCurrencyFormat, getCurrencySymbol };